import { Entity, IEntity } from "./Entity";

export interface IZCoreEmailTemplate extends IEntity {
    TemplateUniqueID?: string;
    Subject?: string;
    Message?: string;
    //CustomerID: number | null;
}

export class ZCoreEmailTemplate extends Entity implements IZCoreEmailTemplate {
    public TemplateUniqueID?: string = null;
    public Subject?: string = null;
    public Message?: string = null;
}